import { FC } from 'react';
import { PhysicalContent } from '@components/EntityDrawers/drawers/Physical/content';
import { PhysicalFormValues } from '@components/EntityDrawers/drawers/Physical/form';
import { PhysicalSettings } from '@components/EntityDrawers/drawers/Physical/settings';
import withDrawer from '@components/EntityDrawers/hocs/withDrawer';
import withTabs from '@components/EntityDrawers/hocs/withTabs';
import { Modes } from '@constants/canvas/layers';
import { ProjectDrawerTypes } from '@constants/entities/drawers';
import {
  ProjectViewOnlyProvider,
  useProject,
} from '@context/Project/ProjectProvider';
import { PhysicalMetaData } from '@store/services/nodes/types';

type Type =
  | ProjectDrawerTypes.AddPhysicalEntity
  | ProjectDrawerTypes.EditPhysicalEntity;

const PhysicalDrawerBase = withTabs<Type>(
  withDrawer<PhysicalFormValues, PhysicalMetaData, Type>(
    PhysicalContent,
    PhysicalSettings,
  ),
);

export const PhysicalDrawer: FC<{ type: Type }> = ({ type }) => {
  const {
    toolbox: { mode },
  } = useProject();

  return (
    <ProjectViewOnlyProvider enabled={mode === Modes.RiskManagement}>
      <PhysicalDrawerBase type={type} />
    </ProjectViewOnlyProvider>
  );
};
